import { render, staticRenderFns } from "./course_content1.vue?vue&type=template&id=d0c906a8&scoped=true&"
import script from "./course_content1.vue?vue&type=script&lang=js&"
export * from "./course_content1.vue?vue&type=script&lang=js&"
import style0 from "./course_content1.vue?vue&type=style&index=0&id=d0c906a8&lang=scss&scoped=true&"
import style1 from "./course_content1.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c906a8",
  null
  
)

export default component.exports